"use client";
import type { DivisionsTree, OfficeWithFloors } from "@gettactic/api";
import { useDivisionsMenuQuery } from "@gettactic/hooks";
import { useMemo } from "react";

interface DivisionCategories {
  offices: Record<string, OfficeWithFloors>;
  tree: DivisionsTree | null;
}

export function useDivisionCategories(): DivisionCategories {
  const divisions = useDivisionsMenuQuery({ getFloors: true });

  return useMemo(() => {
    const divisionsData: DivisionCategories = {
      offices: {},
      tree: divisions.data?.tree || null
    };

    const iterateDivisionTree = (division: DivisionsTree) => {
      if (division.offices) {
        division.offices.forEach((office) => {
          divisionsData.offices[office.id] = {
            ...office,
            floors: division.floors || []
          };
        });
      }

      if (division.children) {
        division.children.forEach(iterateDivisionTree);
      }
    };

    if (divisions.data?.tree) {
      iterateDivisionTree(divisions.data.tree);
    }

    return divisionsData;
  }, [divisions.data?.tree]);
}
